import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import { computed, onMounted } from "vue";
import { appStore, useScreen } from "@/hooks";
import { navigateTo, Routes } from "@/router";
import { FlexBox, IconButton, SafaIcon } from "@/components/common";
import NavOptions from "./NavOptions.vue";
import NavAccount from "./NavAccount.vue";


/**
 * Renders the navigation drawer.
 */
const __default__ = {
  name: "AppNavDrawer",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { smallWindow } = useScreen();

const sidebarOpen = computed({
  get(): boolean {
    return appStore.popups.navPanel;
  },
  set() {
    appStore.toggle("navPanel");
  },
});

/**
 * Navigates to the home page when the logo is clicked.
 */
function handleLogoClick(): void {
  navigateTo(Routes.HOME);
}

onMounted(() => {
  if (!smallWindow) return;

  appStore.close("navPanel");
});

return (_ctx: any,_cache: any) => {
  const _component_q_drawer = _resolveComponent("q-drawer")!

  return (_openBlock(), _createBlock(_component_q_drawer, {
    breakpoint: 0,
    mini: !sidebarOpen.value,
    "mini-width": 65,
    width: 260,
    "model-value": "",
    persistent: "",
    bordered: ""
  }, {
    default: _withCtx(() => [
      (sidebarOpen.value)
        ? (_openBlock(), _createBlock(_unref(FlexBox), {
            key: 0,
            align: "center",
            class: "nav-sidebar-header-open",
            "full-width": "",
            justify: "between",
            y: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SafaIcon), {
                hidden: !sidebarOpen.value,
                clickable: "",
                onClick: handleLogoClick
              }, null, 8, ["hidden"]),
              _createVNode(_unref(IconButton), {
                color: "primary",
                "data-cy": "button-sidebar-close",
                icon: "nav-toggle",
                tooltip: "Close sidebar",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false))
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_unref(FlexBox), {
            key: 1,
            align: "center",
            class: "nav-sidebar-header",
            "full-width": "",
            justify: "center",
            y: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IconButton), {
                "data-cy": "button-sidebar-open",
                icon: "safa",
                tooltip: "Open sidebar",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = true))
              })
            ]),
            _: 1
          })),
      _createVNode(NavOptions),
      _createVNode(NavAccount)
    ]),
    _: 1
  }, 8, ["mini"]))
}
}

})